<app-pop-up
	[id]="popUpId"
	[options]="{}"
>
	<div
		class="popup popup-biometrics-registration-success"
		[ngClass]="{
			'popup-biometrics-registration-success--step-0': stepIndex === 0,
			'popup-biometrics-registration-success--step-1': stepIndex === 1,
		}"
	>
		<app-loader
			#loaderStep1
			[context]="'element'"
			[isActive]="false"
		></app-loader>
		<button
			class="button-reset close"
			type="button"
			(click)="close()"
		></button>

		<div class="popup__content popup-biometrics-registration-success__content">
			@switch (stepIndex) {
				@case (0) {
					<div>
						<section>
							<h3 class="popup__header">Предложение и Заявление</h3>
							<div
								class="popup__body popup-biometrics-registration-success__body popup-biometrics-registration-success__body--with-background"
							>
								<h4
									class="popup-biometrics-registration-success__body-title popup-biometrics-registration-success__body-title--center"
								>
									Заявление о&nbsp;заключении Договора о&nbsp;карте Банк
									в&nbsp;кармане Digital и&nbsp;Договора дистанционного
									обслуживания
								</h4>
								<section
									class="popup-biometrics-registration-success__body-content"
								>
									<app-layout-renderer [layout]="layout"></app-layout-renderer>
								</section>
								<app-error-presenter [errors]="errors"></app-error-presenter>
							</div>
							<div
								class="popup__footer popup-biometrics-registration-success__footer"
							>
								<button
									class="button button--white"
									type="button"
									(click)="close()"
								>
									Не принимаю
								</button>
								<button
									class="button"
									type="button"
									(click)="next1()"
								>
									Принимаю
								</button>
							</div>
						</section>
					</div>
				}
				@case (1) {
					<div>
						<section>
							<h3 class="popup__header">Это важно!</h3>
							<div class="popup__body popup-biometrics-registration-success__body">
								<h4 class="popup-biometrics-registration-success__body-title">
									Вам необходимо:
								</h4>
								<ul class="popup-biometrics-registration-success__list">
									<li class="popup-biometrics-registration-success__list-item">
										<div
											class="popup-biometrics-registration-success__list-item-number"
										>
											1
										</div>
										<div
											class="popup-biometrics-registration-success__list-item-text"
										>
											Сфотографироваться и&nbsp;записать образец голоса
											в&nbsp;отделении любого из&nbsp;
											<a
												class="link"
												target="_blank"
												href="https://bio.rt.ru/citizens/#map-selects"
											>
												банков
											</a>
											&nbsp;РФ, предоставляющих услугу передачи биометрических
											данных в&nbsp;Единую биометрическую систему&nbsp;РФ
										</div>
									</li>
									<li class="popup-biometrics-registration-success__list-item">
										<div
											class="popup-biometrics-registration-success__list-item-number"
										>
											2
										</div>
										<div
											class="popup-biometrics-registration-success__list-item-text"
										>
											Ввести свой логин и&nbsp;пароль от&nbsp;портала
											Госуслуги (у&nbsp;васдолжна быть подтвержденная учетная
											запись). Подтвердить личность, сделав видео
											и&nbsp;записав образец голоса. Подтвердить передачу
											ваших данных Банку
										</div>
									</li>
								</ul>
								<h4 class="popup-biometrics-registration-success__body-title">
									Что дальше?
								</h4>
								<p>
									Если Ваши фото и&nbsp;образец голоса совпадут с&nbsp;данными,
									хранящимися в&nbsp;Единой биометрической системе РФ,
									Вы&nbsp;сможете получить карту со&nbsp;всеми возможностями, как
									и&nbsp;клиенты, посетившие отделения банков лично.
								</p>
								<section class="popup-biometrics-registration-success__logotyps">
									<ul
										class="popup-biometrics-registration-success__logotyps-list"
									>
										<li
											class="popup-biometrics-registration-success__logotyps-list-item"
										>
											<div class="rostelecom-logo">
												<img
													alt=""
													src="../../../../assets/images/icons/rostelecom-logo.png"
												/>
											</div>
										</li>
										<li
											class="popup-biometrics-registration-success__logotyps-list-item"
										>
											<div class="biometrics-system-logo">
												<div class="biometrics-system-logo__icon">
													<app-svg-biometrics-photo></app-svg-biometrics-photo>
												</div>
												<span class="biometrics-system-logo__text">
													Единая биометрическая система
												</span>
											</div>
										</li>
									</ul>
								</section>
								<app-error-presenter [errors]="errors"></app-error-presenter>
							</div>
							<div
								class="popup__footer popup-biometrics-registration-success__footer"
							>
								<button
									class="button button--white"
									type="button"
									(click)="close()"
								>
									Не принимаю
								</button>
								<button
									class="button"
									type="button"
									(click)="next2()"
								>
									Принимаю
								</button>
							</div>
						</section>
					</div>
				}
			}
		</div>
	</div>
</app-pop-up>
